import * as React from 'react';
import AppContainer from './AppContainer';
import {CONTENT_TYPE} from '../../Config/appConfig';

class ApiUsersContainer extends React.Component <{}, {}> {
    public render() {
        return (
            <AppContainer content={CONTENT_TYPE.API_USERS}/>
        );
    }
}

export default ApiUsersContainer;



// WEBPACK FOOTER //
// ./src/Components/Containers/ApiUsersContainer.tsx